import { WidgetId } from '../../api/useWidgetsQuery';

export const ICON_MAP: Record<WidgetId, string> = {
  'market-value': 'fas fa-chart-line',
  return: 'fas fa-chart-line',
  'activity-summary': 'fas fa-chart-line',
  'pv-vs-nai': 'fas fa-chart-bar',
  'allocation-slot-a': 'fas fa-chart-bar',
  'allocation-slot-b': 'fas fa-chart-bar',
  'performance-summary': 'fas fa-chart-line',
  'performance-vs-benchmark': 'fas fa-chart-line',
  'performance-details': 'fas fa-chart-line',
  'projected-income': 'fas fa-chart-bar',
  'income-details': 'fas fa-chart-line',
  'performance-chart': 'fas fa-chart-bar',
};

export const ADD_CARD_BUTTON_CONTAINER_ID = 'customize-widgets--add-card--button';

export const WIDGETS_WITH_GROUP_SELECTION: WidgetId[] = [
  'performance-details',
  'income-details',
  'performance-chart',
];
